<script setup lang="ts">
import { Toaster as Sonner } from 'vue-sonner'

const props = withDefaults(
  defineProps<{
    position?:
      | 'top-left'
      | 'top-right'
      | 'bottom-left'
      | 'bottom-right'
      | 'top-center'
      | 'bottom-center'
    duration?: number
    richColors?: boolean
    expand?: boolean
    closeButton?: boolean
  }>(),
  {
    position: 'bottom-right',
    duration: 4000,
    richColors: true,
    expand: false,
    closeButton: false,
  }
)
</script>

<template>
  <Sonner
    class="toaster-with-progress"
    :position="props.position"
    :duration="props.duration"
    :rich-colors="props.richColors"
    :expand="props.expand"
    :close-button="props.closeButton"
    :style="{ '--toast-duration': `${props.duration}ms` }"
  />
</template>

<style>
.toaster-with-progress [data-sonner-toast] {
  --toast-progress-height: 3px;
  --toast-duration: 4000ms;
  position: relative;
  overflow: hidden;
}

.toaster-with-progress [data-sonner-toast]::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: var(--toast-progress-height);
  width: 100%;
  background: currentColor;
  opacity: 0.3;
  animation: toast-progress var(--toast-duration, 4000ms) linear forwards;
  transform-origin: left;
}

.toaster-with-progress [data-sonner-toast][data-type='error']::after {
  animation-duration: 5000ms;
}

@keyframes toast-progress {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}
</style>
